export default "__VITE_ASSET__c75c0ef0__"